import { render, staticRenderFns } from "./GraficoAcordos.vue?vue&type=template&id=478cae93"
import script from "./GraficoAcordos.vue?vue&type=script&lang=js"
export * from "./GraficoAcordos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports